import { Module, StatusPanelDef } from '@ag-grid-community/core'
import { EnterpriseCoreModule } from '@ag-grid-enterprise/core'
import { StatusBarModule } from '@ag-grid-enterprise/status-bar'
import { SelectedRowsStatusBarComp } from '@helios/generic-components'
import { TotalRowsCountStatusBar } from './total-rows-status-bar'

export const accountListStatusBarModuleName =
  'hsExternalAccountsStatusBarModule'
export const totalRowsStatusBar = 'hsTotalRowsStatusBar'
export const selectedRowsStatusBar = 'hsSelectedRowsStatusBar'

export const accountListStatusBarPanel: { statusPanels: StatusPanelDef[] } = {
  statusPanels: [
    {
      statusPanel: totalRowsStatusBar,
      align: 'left',
    },
    {
      statusPanel: selectedRowsStatusBar,
      align: 'left',
    },
  ],
}

export const AccountListStatusBarModule: Module = {
  moduleName: accountListStatusBarModuleName,
  userComponents: [
    {
      componentName: totalRowsStatusBar,
      componentClass: TotalRowsCountStatusBar,
    },
    {
      componentName: selectedRowsStatusBar,
      componentClass: SelectedRowsStatusBarComp,
    },
  ],
  dependantModules: [StatusBarModule, EnterpriseCoreModule],
}
